import { linkWhatsApp } from '../data/conteudo';
import { IconeWhatsApp } from './Icones';
import styles from './BotaoWhatsApp.module.css';

// Botão flutuante, visível só no celular, para agendar de qualquer ponto da página.
const BotaoWhatsApp = () => (
  <a
    className={styles.botao}
    href={linkWhatsApp}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Agendar consulta pelo WhatsApp"
  >
    <IconeWhatsApp />
  </a>
);

export default BotaoWhatsApp;
